<template>
  <div class="edu-pay-section">
    <p class="section-title">수업 횟수 / 시간</p>
    <div class="table-wrap">
    <table class="form-table">
      <thead>
        <tr>
          <th>
            <span class="font-bold">*</span>
            수업 횟수
          </th>
          <th>
            <span class="font-bold">*</span>
            요일
          </th>
          <th>
            <span class="font-bold">*</span>
            총 수업 횟수
          </th>
          <th>
            <span class="font-bold">*</span>
            수업 시간(분)
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in registSugang.sugangOneTimeInfo" :key="index">
          <td>
            <div class="time-inline-group">
              <p class="inline-unit">주</p>
              <select
                v-model="registSugang.sugangOneTimeInfo[index].numberOfClass"
                class="table-control table-select count-select"
                @change="registSugang.changeDefaultLecDayList(registSugang.sugangOneTimeInfo[index])"
              >
                <option value="0" selected>선택</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="5">5</option>
              </select>
              <p class="inline-unit">회</p>
            </div>
          </td>
          <td>
            <div class="time-inline-group">
              <ul class="day-option-list">
                <li
                  v-for="(item, lecDayIndex) in registSugang.sugangOneTimeInfo[index].lecDayList"
                  :key="lecDayIndex"
                  class="day-option-item"
                >
                  <label class="day-option-label" :for="'chk1_' + index + '_' + lecDayIndex">
                    <input
                    type="checkbox"
                    :id="'chk1_' + index + '_' + lecDayIndex"
                    v-model="item.checked"
                    @change="registSugang.validationLecDay(sugangOneTimeInfo[index], item)"
                  />
                    <span>{{ item.label }}</span>
                  </label>
                </li>
              </ul>
            </div>
          </td>
          <td>
            <div class="time-inline-group">
              <p class="inline-unit">총</p>
              <input
                type="text"
                class="table-control count-input"
                v-model="registSugang.sugangOneTimeInfo[index].totalNumberOfClass"
              />
              <p class="inline-unit">회</p>
            </div>
          </td>
          <td>
            <input
              type="text"
              class="table-control"
              v-model="registSugang.sugangOneTimeInfo[index].lessonTime"
            />
          </td>
          <td>
            <button type="button" class="secondary-inline-button" @click="registSugang.deleteRows(index)">삭제</button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <div class="flex justify-end">
      <button type="button" class="secondary-inline-button" @click="registSugang.addRows">
        추가입력
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, computed, watch, watchEffect } from "vue";

class BaseOneTimeObject {
  constructor() {
    this.idxLeSugangOneTimeInfo = 0;
    this.idxLeSugang = 0;
    this.numberOfClass = "";
    this.lecDayList = new Array(
      {
        label: "월",
        checked: false,
      },
      {
        label: "화",
        checked: false,
      },
      {
        label: "수",
        checked: false,
      },
      {
        label: "목",
        checked: false,
      },
      {
        label: "금",
        checked: false,
      },
      {
        label: "토",
        checked: false,
      },
      {
        label: "일",
        checked: false,
      }
    );
    this.lessonTime = "";
    this.totalNumberOfClass = "";
    this.staffIdx = 0;
  }
}

export default {
  name: "RegistOneClassEduPay",
  components: {},
  props: {
    sugangOneTimeInfo: Array,
  },
  setup(props, { emit }) {
    const registSugang = reactive({
      sugangOneTimeInfo: props.sugangOneTimeInfo,

      addRows: () => {
        let bo = new BaseOneTimeObject();

        if (registSugang.sugangOneTimeInfo == undefined) registSugang.sugangOneTimeInfo = [];
        registSugang.sugangOneTimeInfo.push(bo);
        return registSugang.sugangOneTimeInfo.length;
      },
      deleteRows: (index) => {
        if (index > -1) {
          registSugang.sugangOneTimeInfo.splice(index, 1);
        }
      },

      //요일 설정 정보 기본값 설정 메서드
      changeDefaultLecDayList(oneTimeInfo) {
        const { numberOfClass, lecDayList } = oneTimeInfo;

        // 체크된 요일 정보 초기화
        lecDayList.forEach((lecDay) => (lecDay.checked = false));

        switch (String(numberOfClass)) {
          // 선택하지 않음
          case "0":
            break;
          // 주 2회는 화, 목
          case "2":
            this.checkedLecDay(lecDayList, 1);
            this.checkedLecDay(lecDayList, 3);
            break;
          // 주 3회는 월, 수, 금
          case "3":
            this.checkedLecDay(lecDayList, 0);
            this.checkedLecDay(lecDayList, 2);
            this.checkedLecDay(lecDayList, 4);
            break;
          // 주 3회는 월, 화, 수, 목, 금
          case "5":
            this.checkedLecDay(lecDayList, 0);
            this.checkedLecDay(lecDayList, 1);
            this.checkedLecDay(lecDayList, 2);
            this.checkedLecDay(lecDayList, 3);
            this.checkedLecDay(lecDayList, 4);
            break;
        }
      },

      // 요일 선택
      checkedLecDay(lecDayList, weekOfDay) {
        lecDayList[weekOfDay].checked = true;
      },

      // 요일 설정 정보의 유효성 검증 메서드
      validationLecDay(oneTimeInfo, lecDay) {
        const { numberOfClass, lecDayList } = oneTimeInfo;

        const currentCheckedLecDayCount = lecDayList.filter((lecDay) => lecDay.checked).length;

        if (currentCheckedLecDayCount > numberOfClass) {
          // 수업 횟수 주 N회를 초과할 수 없음
          lecDay.checked = false;
        }
      },
    });

    onMounted(() => {
      registSugang.addRows();
    });

    watch(
      () => props.sugangOneTimeInfo,
      (cur, prev) => {
        cur.forEach((oneTimeInfo) => {
          const bo = new BaseOneTimeObject();

          const { lecDayList } = oneTimeInfo;
          if (!lecDayList) {
            // 기존 규격에 요일 설정 정보 목록이 없는 경우 기본값 생성
            oneTimeInfo.lecDayList = bo.lecDayList;

            registSugang.changeDefaultLecDayList(oneTimeInfo);
          } else {
            // 요일 설정 정보 목록이 있는 경우
            lecDayList.forEach((lecDay, index) => {
              // 요일 이름 설정
              lecDay.label = bo.lecDayList[index].label;
            });
          }
        });

        registSugang.sugangOneTimeInfo = cur;
      }
    );

    watch(
      () => registSugang.sugangOneTimeInfo,
      (cur, prev) => {
        // 이벤트를 통해 부모로 데이터셋을 전달.
        emit("set-edupay-data", cur); // 일단 주석처리.
      }
    );

    return {
      registSugang,
    };
  },
};
</script>

<style scoped>
.edu-pay-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-title {
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
}

.form-table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #fff;
}

.form-table thead th {
  background: #f8fafc;
  padding: 0.9rem 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
  text-align: center;
}

.form-table tbody td {
  padding: 0.85rem;
  border-top: 1px solid #e2e8f0;
  vertical-align: middle;
}

.time-inline-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  flex-wrap: wrap;
}

.inline-unit {
  font-size: 0.875rem;
  color: #64748b;
}

.table-control {
  width: 100%;
  min-height: 2.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.7rem 0.9rem;
  font-size: 0.95rem;
  color: #0f172a;
  outline: none;
}

.table-control:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.table-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  padding-right: 2.5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%2364758b' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 0.9rem;
}

.count-select {
  max-width: 6.5rem;
}

.count-input {
  max-width: 4.5rem;
  text-align: center;
}

.day-option-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.day-option-item {
  list-style: none;
}

.day-option-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  padding: 0.5rem 0.75rem;
  font-size: 0.82rem;
  color: #334155;
  cursor: pointer;
}

.secondary-inline-button {
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.65rem 0.95rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
}

.secondary-inline-button:hover {
  background: #f8fafc;
}

input[type="checkbox"] {
  accent-color: #2563eb;
}
</style>
